import * as React from "react";
import type { SVGProps } from "react";
const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M10 5.855S8.515 4 6.61 4a3.68 3.68 0 0 0-3.27 2.136 3.69 3.69 0 0 0 .488 3.877c.464.601 5.563 5.73 5.563 5.73A.86.86 0 0 0 10 16a.86.86 0 0 0 .6-.258s5.108-5.154 5.572-5.73A3.686 3.686 0 0 0 13.39 4C11.486 4 10 5.855 10 5.855" />
  </svg>
);
export default SvgHeart;
